import { GET_CABINS_DATA } from './../constants/actionTypes'

const cabins = (store = [], action = {}) => {
  switch (action.type) {
    case GET_CABINS_DATA:
      return action.data.data
    default:
      return store
  }
}

export default cabins
